module.exports = __webpack_public_path__ + "83e97d8865204f3c2350ff920b5a7b7e.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics1/14.png
// module id = 282
// module chunks = 0